import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import "./EarningChart.css";

export default function EarningChart() {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    const canvas = chartRef.current;
    if (!canvas) return;

    // destroy previous chart if exists (prevents "Canvas is already in use" error)
    const existing = Chart.getChart(canvas);
    if (existing) existing.destroy();

    const ctx = canvas.getContext("2d");
    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        datasets: [{
          label: "Earnings (7d)",
          data: [120, 180, 300, 150, 220, 380, 410],
          borderColor: "#b44bff",
          backgroundColor: "rgba(180,75,255,0.12)",
          tension: 0.35,
          pointRadius: 5,
          pointBackgroundColor: "#ff7bff",
          borderWidth: 3,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { labels: { color: "#fff" } }
        },
        scales: {
          x: { ticks: { color: "#cfcfe0" }, grid: { color: "rgba(255,255,255,0.03)" } },
          y: { ticks: { color: "#cfcfe0" }, grid: { color: "rgba(255,255,255,0.03)" } }
        }
      }
    });

    return () => {
      if (chartInstanceRef.current) chartInstanceRef.current.destroy();
    };
  }, []);

  return (
    <div className="chartBox">
      <canvas ref={chartRef} />
    </div>
  );
}
